<template>
    <div class="welfare-voucher-detail-container">
        <van-nav-bar title="优惠券详情" />
        <div class="voucher-info-box">
            <div class="info-left">
                <div class="voucher-info">
                    <div class="type">{{ mallBoon.type | fType }}</div>
                    <div class="nmae">{{ mallBoon.boonName }}</div>
                </div>
                <div class="voucher-num">
                    <span>人均限{{ mallBoon.dayLimitNumber }}张 </span>
                    <span> · </span>
                    <span>每天限{{ mallBoon.daySellLimit }}张 </span>
                    <span> · </span>
                    <span>满{{ mallBoon.totalPrice }}可用</span>
                </div>
            </div>
            <div class="info-right">已领取{{ mallBoon.snappedNum }}张</div>
        </div>
        <div class="merchant-info">
            <div class="info">
                <div class="top">商家信息</div>
                <div class="df">
                    <div class="left">
                        <img :src="mallBoon.mallOrgLogo" alt="" />
                    </div>
                    <div class="right">
                        <div class="title">{{ mallBoon.mallOrgName }}</div>
                        <div class="fullTitle">{{ mallBoon.mallOrgFullName }}</div>
                        <span class="type" v-for="(item, index) in malllabelList" :key="index">{{ item.labelName }}</span>
                        <div class="address"><van-icon name="location-o" /> {{ mallBoon.mallOrgAddress }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="merchant-info">
            <div class="time">
                <div class="top">有效期限</div>
                <div>{{ mallBoon.indateStartTime }} 至 {{ mallBoon.indateEndTime }}</div>
            </div>
        </div>
        <div class="merchant-info">
            <div class="use">
                <div class="top">使用规则</div>
                <div>{{ mallBoon.rule }}</div>
            </div>
        </div>
        <div class="use-store-box">
            <div class="top">可使用门店（{{ mallbranchstoreList.length }}）</div>
            <div class="storeList">
                <div class="storeItem" v-for="(item, index) in mallbranchstoreList" :key="index">
                    <div class="df-csb">
                        <div class="left">{{ item.simpleName }}</div>
                        <div class="right">
                            <van-icon name="calendar-o" /> {{ item.openStartWeek | fWeek }}至{{ item.openEndWeek | fWeek }}
                            {{ item.openStartTime }}-{{ item.openEndTime }}
                        </div>
                    </div>
                    <div class="bottom"><van-icon name="location-o" /> {{ item.fullAddress }}</div>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <van-button type="default" color="#FF6633" block @click="goBack"> 门店管理 </van-button>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { getMallBoonById } from '../api/index';
export default {
    data() {
        return {
            id: '',
            mallBoon: {},
            malllabelList: [],
            mallbranchstoreList: [],
            imageuHost: 'https://file.pzhszgh.cn'
        };
    },
    methods: {
        getMallBoonById() {
            getMallBoonById(this.id).then((res) => {
                // mallBoon
                this.mallBoon = res.data.mallBoon;
                this.mallBoon.mallOrgLogo = this.imageuHost + res.data.mallBoon.mallOrgLogo;
                this.mallBoon.indateStartTime = this.formatTime(this.mallBoon.indateStartTime);
                this.mallBoon.indateEndTime = this.formatTime(this.mallBoon.indateEndTime);

                // malllabelList
                this.malllabelList = res.data.malllabelList;

                // mallbranchstoreList
                this.mallbranchstoreList = res.data.mallbranchstoreList;
            });
        },
        formatTime(e) {
            return moment(e).format('YYYY--MM-DD HH:mm');
        },
        goBack(){
             this.$router.go(-1);
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.getMallBoonById();
    },
    filters: {
        fType: function (value) {
            if (value === 2) return '折扣券';
            if (value === 3) return '兑换券';
            if (value === 4) return '满减券';
            if (value === 5) return '现金券';
        },
        fWeek: function (value) {
            if (value === 1) return '周一';
            if (value === 2) return '周二';
            if (value === 3) return '周三';
            if (value === 4) return '周四';
            if (value === 5) return '周五';
            if (value === 6) return '周六';
            if (value === 7) return '周日';
        }
    }
};
</script>

<style scopde lang="scss">
.welfare-voucher-detail-container {
    margin: 0 10px;
    font-size: 14px;
    .voucher-info-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        margin-top: 10px;
        border-radius: 6px;
        background-color: #eeeeee;

        .info-left {
            .voucher-info {
                display: flex;
                margin-bottom: 10px;

                .type {
                    background-color: #fb7b7b;
                    padding: 0 5px;
                    margin-right: 5px;
                    border-radius: 6px;
                    color: #ffffff;
                }
            }

            .voucher-num {
            }
        }
    }
    .merchant-info {
        margin-top: 10px;
        background-color: #eeeeee;
        padding: 10px;

        .info {
            .df {
                img {
                    width: 70px;
                    height: 70px;
                    margin: 5px 10px 5px 0;
                }
                .right {
                    .title {
                        font-size: 16px;
                        font-weight: 600;
                    }
                    .type {
                        background-color: #fb7b7b;
                        padding: 0 5px;
                        margin-right: 5px;
                        border-radius: 6px;
                        color: #ffffff;
                    }
                }
            }
        }
        .time {
        }
    }
    .use-store-box {
        margin-top: 10px;
        background-color: #eeeeee;
        padding: 10px;
        .storeItem {
            padding: 5px;
            border-bottom: 1px solide #333;
        }
    }
    .btn-box {
        position: fixed;
        bottom: 10px;
        width: 350px;
    }
    .top {
        font-size: 18px;
        font-weight: 600;
    }
}
</style>
